//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the HTML for the PDF export button
     * @param disabled (optional) 
     * @param version (optional) 
     * @return The HTML of the button
     */
    apiTableauIntegrationPdfExportButtonHtml(disabled?: boolean | undefined, version?: ToolbarVersion | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/tableau-integration/pdf-export/button-html?";
        if (disabled === null)
            throw new Error("The parameter 'disabled' cannot be null.");
        else if (disabled !== undefined)
            url_ += "disabled=" + encodeURIComponent("" + disabled) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/html"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTableauIntegrationPdfExportButtonHtml(_response);
        });
    }

    protected processApiTableauIntegrationPdfExportButtonHtml(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export enum ErrorTypes {
    UnhandledError = "unhandledError",
    InvalidInput = "invalidInput",
    NoBody = "noBody",
    FailedToDelete = "failedToDelete",
    NotAuthorized = "notAuthorized",
    TokenInvalid = "tokenInvalid",
    InvalidCredentials = "invalidCredentials",
    AdServerDown = "adServerDown",
    AdUserNotFound = "adUserNotFound",
    UserHasNoPassword = "userHasNoPassword",
    AppleConnectCookieMissing = "appleConnectCookieMissing",
    AppleConnectValidationError = "appleConnectValidationError",
    AppleConnectUserMissingInLDAP = "appleConnectUserMissingInLDAP",
    WorkspaceNotFound = "workspaceNotFound",
    WorkspaceNotAuthorized = "workspaceNotAuthorized",
    WorkspaceNameAlreadyExists = "workspaceNameAlreadyExists",
    ServerNotFound = "serverNotFound",
    ServerNameAlreadyExists = "serverNameAlreadyExists",
    DatasourceNotFound = "datasourceNotFound",
    InvalidConnectionString = "invalidConnectionString",
    InvalidDatasourceCredentials = "invalidDatasourceCredentials",
    DatasourceConnectionError = "datasourceConnectionError",
    DatasourceError = "datasourceError",
    DatasourceNameAlreadyExists = "datasourceNameAlreadyExists",
    DatasourceAuthTypeNotAllowed = "datasourceAuthTypeNotAllowed",
    DatasourceOAuthNotAllowedForConnection = "datasourceOAuthNotAllowedForConnection",
    DatasourceModeInvalid = "datasourceModeInvalid",
    DatasourceTypeNotEnabled = "datasourceTypeNotEnabled",
    AnnotationRuleNotFound = "annotationRuleNotFound",
    AnnotationRuleAccessForbidden = "annotationRuleAccessForbidden",
    FormInvalid = "formInvalid",
    RecordNotFound = "recordNotFound",
    CannotRespond = "cannotRespond",
    AnnotationRuleNameAlreadyExists = "annotationRuleNameAlreadyExists",
    NotificationChannelDefinedMultipleTimes = "notificationChannelDefinedMultipleTimes",
    FieldEditForbidden = "fieldEditForbidden",
    AnnotationConcurencyError = "annotationConcurencyError",
    AnnotationForceUpdateForbidden = "annotationForceUpdateForbidden",
    ExcelExportForbidden = "excelExportForbidden",
    MigrationTargetNotFound = "migrationTargetNotFound",
    MigrationTargetInvalidStatus = "migrationTargetInvalidStatus",
    MigrationTargetNameAlreadyExists = "migrationTargetNameAlreadyExists",
    MigrationTargetCommunicationError = "migrationTargetCommunicationError",
    FailedToCreateJwtKey = "failedToCreateJwtKey",
    ExtensionConfigMigrationNotFound = "extensionConfigMigrationNotFound",
    NotificationChannelNotFound = "notificationChannelNotFound",
    NotificationChannelNameAlreadyExists = "notificationChannelNameAlreadyExists",
    NotificationChannelStatusError = "notificationChannelStatusError",
    OtpNotFoundOrExpired = "otpNotFoundOrExpired",
    UserAlreadySetUp = "userAlreadySetUp",
    PrincipalWithNameAlreadyExists = "principalWithNameAlreadyExists",
    PrincipalNotFound = "principalNotFound",
    MembershipNotFound = "membershipNotFound",
    AlreadyAMember = "alreadyAMember",
    LicenseError = "licenseError",
    LicenseFeatureDisabled = "licenseFeatureDisabled",
    LicenseWorkspacesExceeded = "licenseWorkspacesExceeded",
    OAuthLoginError = "oAuthLoginError",
    Outdated = "outdated",
    ManagedDatasourceNotFound = "managedDatasourceNotFound",
    ManagedDatasourceRolesMissing = "managedDatasourceRolesMissing",
    ManagedDatasourceTypeCannotBeChanged = "managedDatasourceTypeCannotBeChanged",
    PatNameAlreadyExists = "patNameAlreadyExists",
    PatNotFound = "patNotFound",
    ActivePatCannotBeDeleted = "activePatCannotBeDeleted",
    BridgeNameAlreadyExists = "bridgeNameAlreadyExists",
    BridgeNotFound = "bridgeNotFound",
    BridgeNoConnections = "bridgeNoConnections",
    BridgeConnectionTimeout = "bridgeConnectionTimeout",
    FileStorageNotFound = "fileStorageNotFound",
    FileStorageStatusError = "fileStorageStatusError",
    FileStorageNameAlreadyExists = "fileStorageNameAlreadyExists",
    AutoMigrationNotFound = "autoMigrationNotFound",
    LogFilePathNotConfigured = "logFilePathNotConfigured",
    LogFilePathNotFound = "logFilePathNotFound",
}

export class ErrorTypesErrorResponseDTO implements IErrorTypesErrorResponseDTO {
    requestId?: string | undefined;
    error?: ErrorTypes;
    message?: string | undefined;
    details?: any | undefined;

    constructor(data?: IErrorTypesErrorResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.error = _data["error"];
            this.message = _data["message"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): ErrorTypesErrorResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorTypesErrorResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["error"] = this.error;
        data["message"] = this.message;
        data["details"] = this.details;
        return data;
    }

    clone(): ErrorTypesErrorResponseDTO {
        const json = this.toJSON();
        let result = new ErrorTypesErrorResponseDTO();
        result.init(json);
        return result;
    }
}

export interface IErrorTypesErrorResponseDTO {
    requestId?: string | undefined;
    error?: ErrorTypes;
    message?: string | undefined;
    details?: any | undefined;
}

export enum ToolbarVersion {
    Pre2022 = "pre2022",
    Post2022 = "post2022",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}